export const SOCIAL_TWITTER = "https://twitter.com/VoxelArchitects";
export const SOCIAL_LINKEDIN =
  "https://www.linkedin.com/company/voxelarchitects";
export const SOCIAL_INSTAGRAM = "https://instagram.com/voxel.architects";
export const SOCIAL_MEDIUM = "https://medium.com/voxelarchitects";
export const SOCIAL_DISCORD = "";
export const SOCIAL_METAVERSE = "";
export const SOCIAL_CRYPTOVOXELS = "";
export const SOCIAL_DECENTRALAND = "";
